import { render } from "./EmailTest.vue?vue&type=template&id=2103789a"
import script from "./EmailTest.vue?vue&type=script&lang=js"
export * from "./EmailTest.vue?vue&type=script&lang=js"
script.render = render

export default script